import { matchPath } from 'react-router-dom';

/**
 * Whether the URL of an `/apply` request points at a given workflow step.
 *
 * Uses the router's own matcher rather than comparing pathnames, so a trailing
 * slash still matches the step it names.
 */
export const isApplyStep = (url: string, step: string): boolean =>
  matchPath(step, new URL(url).pathname) !== null;
